export default __webpack_public_path__ + "static/media/mode-19.bfaf56c0.svg";